export enum RedirectUriServerErrors {
  URI_LIMIT_EXCEEDED = 'URI_LIMIT_EXCEEDED',
  URI_MIN_LIMIT = 'URI_MIN_LIMIT',
  URI_INVALID_URL = 'URI_INVALID_URL',
  URI_INVALID_PROTOCOL = 'URI_INVALID_PROTOCOL',
  URI_INVALID_HOST = 'URI_INVALID_HOST',
  URI_WILDCARD_NOT_ALLOWED = 'URI_WILDCARD_NOT_ALLOWED',
  URI_ONE_WILDCARD_ALLOWED = 'URI_ONE_WILDCARD_ALLOWED',
  URI_INVALID_WILDCARD_HOST = 'URI_INVALID_WILDCARD_HOST',
  DEFAULT_REDIRECT_URI_MISMATCH = 'DEFAULT_REDIRECT_URI_MISMATCH'
}
